export function initializeLightbox() {
    const lightbox = document.getElementById("lightbox");
    const lightboxImgWrap = document.getElementById("lightbox-image-wrap");
    const lightboxSourceAvif = document.getElementById("lightbox-source-avif");
    const lightboxSourceWebp = document.getElementById("lightbox-source-webp");
    const lightboxImg = document.getElementById("lightbox-image");
    const lightboxVideoContainer = document.getElementById("lightbox-video-container");
    const lightboxVideo = document.getElementById("lightbox-video");
    const lightboxYouTubeLink = document.getElementById("lightbox-youtube-link");
    const lightboxCaption = document.getElementById("lightbox-caption");
    const closeBtn = document.getElementById("lightbox-close");
    const prevBtn = document.getElementById("lightbox-prev");
    const nextBtn = document.getElementById("lightbox-next");
    
    // Get images from gallery (reference images). Skip anything explicitly
    // opted out via [data-no-lightbox], on it or around it -- e.g. placeholder
    // graphics that shouldn't be clickable since there's nothing to enlarge,
    // or a figure page's details column (logos) among its pictures.
    const galleryImages = Array.from(document.querySelectorAll("#gallery img:not([data-no-lightbox]):not([data-no-lightbox] img)"));
    

    
    if (!lightbox || !lightboxImg || !closeBtn) {
      return;
    }
  
    let currentImages = [];
    let currentIndex = 0;
    let touchStartX = 0;
    let touchEndX = 0;
  
      function showLightbox(index, mediaSet = [], caption = '', type = 'image', videoUrl = '') {
    if (mediaSet[index] || type === 'youtube') {
      currentImages = mediaSet; // Keep same variable name for compatibility
      currentIndex = index;
      
      // Hide all content first
      if (lightboxImgWrap) {
        lightboxImgWrap.classList.add("hidden");
        lightboxImgWrap.classList.add("loading");
        lightboxImgWrap.classList.remove("loaded");
        // While loading, use the smaller loading box to avoid “flash down”.
        const loadingSize = lightboxImgWrap.dataset.loadingSizeClass;
        const loadedSize = lightboxImgWrap.dataset.loadedSizeClass;
        if (loadingSize) loadingSize.split(' ').forEach(c => c && lightboxImgWrap.classList.add(c));
        if (loadedSize) loadedSize.split(' ').forEach(c => c && lightboxImgWrap.classList.remove(c));
      }
      lightboxImg.classList.add("hidden");
      lightboxVideoContainer.classList.add("hidden");
      if (lightboxSourceAvif) lightboxSourceAvif.srcset = "";
      if (lightboxSourceWebp) lightboxSourceWebp.srcset = "";
      
      if (type === 'youtube' || (mediaSet[index] && mediaSet[index].type === 'youtube')) {
        // Show YouTube video
        const url = videoUrl || mediaSet[index].url;
        const videoId = extractYouTubeVideoId(url);
        if (videoId) {
          const newSrc = `https://www.youtube.com/embed/${videoId}?enablejsapi=1`;
          // Only reload iframe if it's a different video
          if (lightboxVideo.src !== newSrc) {
            lightboxVideo.src = newSrc;
          }
          lightboxYouTubeLink.href = url;
          lightboxVideoContainer.classList.remove("hidden");
        }
      } else {
        // Show image
        let webpUrl = null;
        let avifUrl = null;

        if (mediaSet[index] && mediaSet[index].type === 'image') {
          // Programmatic media sets (e.g. gallery media set) provide URLs directly.
          webpUrl = mediaSet[index].url;
          avifUrl = mediaSet[index].avifUrl || mediaSet[index].avif_url || null;
        } else {
          const targetImage = mediaSet[index];
          if (targetImage && targetImage.dataset) {
            webpUrl = targetImage.dataset.fullWebp || targetImage.dataset.full_webp || targetImage.dataset.full || targetImage.src;
            avifUrl = targetImage.dataset.fullAvif || targetImage.dataset.full_avif || null;
          } else {
            webpUrl = targetImage ? targetImage.src : null;
          }
        }

        // Populate <picture> sources for AVIF/WebP fallback.
        if (lightboxSourceAvif) lightboxSourceAvif.srcset = avifUrl || "";
        if (lightboxSourceWebp) lightboxSourceWebp.srcset = webpUrl || "";
        // Show shimmer immediately so navigation feels responsive, then fade image in when loaded.
        if (lightboxImgWrap) {
          lightboxImgWrap.classList.remove("hidden");
          lightboxImgWrap.classList.add("loading");
          lightboxImgWrap.classList.remove("loaded");
          const loadingSize = lightboxImgWrap.dataset.loadingSizeClass;
          const loadedSize = lightboxImgWrap.dataset.loadedSizeClass;
          if (loadingSize) loadingSize.split(' ').forEach(c => c && lightboxImgWrap.classList.add(c));
          if (loadedSize) loadedSize.split(' ').forEach(c => c && lightboxImgWrap.classList.remove(c));
        }

        lightboxImg.classList.add("hidden");
        lightboxImg.style.opacity = "0";
        lightboxImg.onload = () => {
          if (lightboxImgWrap) {
            lightboxImgWrap.classList.remove("loading");
            lightboxImgWrap.classList.add("loaded");
            // Once loaded, allow the container to expand up to the viewport.
            const loadingSize = lightboxImgWrap.dataset.loadingSizeClass;
            const loadedSize = lightboxImgWrap.dataset.loadedSizeClass;
            if (loadingSize) loadingSize.split(' ').forEach(c => c && lightboxImgWrap.classList.remove(c));
            if (loadedSize) loadedSize.split(' ').forEach(c => c && lightboxImgWrap.classList.add(c));
          }
          lightboxImg.classList.remove("hidden");
          lightboxImg.style.opacity = "1";
        };
        lightboxImg.onerror = () => {
          if (lightboxImgWrap) {
            lightboxImgWrap.classList.remove("loading");
            lightboxImgWrap.classList.add("loaded");
            // On error, also expand (so the UI doesn’t stay constrained).
            const loadingSize = lightboxImgWrap.dataset.loadingSizeClass;
            const loadedSize = lightboxImgWrap.dataset.loadedSizeClass;
            if (loadingSize) loadingSize.split(' ').forEach(c => c && lightboxImgWrap.classList.remove(c));
            if (loadedSize) loadedSize.split(' ').forEach(c => c && lightboxImgWrap.classList.add(c));
          }
          lightboxImg.classList.add("hidden");
        };

        lightboxImg.src = webpUrl || "";
      }
      
      // Populate caption element when present and non-empty; hide
      // it otherwise so it doesn't take up vertical space.
      if (lightboxCaption) {
        if (caption && caption.toString().trim().length > 0) {
          lightboxCaption.textContent = caption;
          lightboxCaption.classList.remove("hidden");
        } else {
          lightboxCaption.textContent = "";
          lightboxCaption.classList.add("hidden");
        }
      }

      lightbox.classList.remove("hidden");
      updateNavigationButtons();
    }
  }

  function extractYouTubeVideoId(url) {
    const patterns = [
      /(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([^&\n?#]+)/,
      /youtube\.com\/watch\?.*v=([^&\n?#]+)/
    ];
    
    for (let pattern of patterns) {
      const match = url.match(pattern);
      if (match) return match[1];
    }
    return null;
  }

  function pauseVideo() {
    // Pause YouTube video using postMessage API
    if (lightboxVideo && lightboxVideo.src && lightboxVideo.src.includes('youtube.com')) {
      lightboxVideo.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
    }
  }
  
  function setLightboxWrapSize(mode) {
    if (!lightboxImgWrap) return;
    const loadingSize = lightboxImgWrap.dataset.loadingSizeClass;
    const loadedSize = lightboxImgWrap.dataset.loadedSizeClass;

    if (mode === "loading") {
      if (loadingSize) loadingSize.split(' ').forEach(c => c && lightboxImgWrap.classList.add(c));
      if (loadedSize) loadedSize.split(' ').forEach(c => c && lightboxImgWrap.classList.remove(c));
    } else if (mode === "loaded") {
      if (loadingSize) loadingSize.split(' ').forEach(c => c && lightboxImgWrap.classList.remove(c));
      if (loadedSize) loadedSize.split(' ').forEach(c => c && lightboxImgWrap.classList.add(c));
    }
  }

      function closeLightbox() {
    // Stop video completely when closing lightbox
    if (lightboxVideo && lightboxVideo.src) {
      lightboxVideo.src = "";
    }
    lightbox.classList.add("hidden");
    lightboxImg.src = "";
    lightboxImg.classList.add("hidden");
    if (lightboxImgWrap) {
      lightboxImgWrap.classList.add("hidden");
      lightboxImgWrap.classList.add("loading");
      lightboxImgWrap.classList.remove("loaded");
      setLightboxWrapSize("loading");
    }
    if (lightboxSourceAvif) lightboxSourceAvif.srcset = "";
    if (lightboxSourceWebp) lightboxSourceWebp.srcset = "";
    lightboxVideoContainer.classList.add("hidden");
    if (lightboxCaption) {
      lightboxCaption.textContent = "";
      lightboxCaption.classList.add("hidden");
    }
  }
  
      function showNext(delta) {
    if (currentImages.length > 0) {
      pauseVideo(); // Pause any playing video before switching
      const newIndex = (currentIndex + delta + currentImages.length) % currentImages.length;
      const nextItem = currentImages[newIndex];
      const nextCaption = nextItem ? nextItem.caption : '';
      const nextType = nextItem ? nextItem.type : 'image';
      showLightbox(newIndex, currentImages, nextCaption, nextType);
    }
  }
  
    function handleSwipe() {
      const swipeThreshold = 50; // minimum distance for a swipe
      const swipeDistance = touchEndX - touchStartX;
      
      if (Math.abs(swipeDistance) > swipeThreshold) {
        if (swipeDistance > 0) {
          // Swiped right - go to previous image
          showNext(-1);
        } else {
          // Swiped left - go to next image
          showNext(1);
        }
      }
    }
  
          // Function to update navigation buttons
  function updateNavigationButtons() {
    // Show/hide navigation buttons based on whether we have multiple items
    if (currentImages.length > 1) {
      prevBtn.classList.remove("hidden");
      nextBtn.classList.remove("hidden");
    } else {
      prevBtn.classList.add("hidden");
      nextBtn.classList.add("hidden");
    }
  }
  
    // Add touch event handlers
    lightbox.addEventListener("touchstart", (e) => {
      touchStartX = e.touches[0].clientX;
    });
  
    lightbox.addEventListener("touchend", (e) => {
      touchEndX = e.changedTouches[0].clientX;
      handleSwipe();
    });
  
      // Set up click handlers for gallery images only
  galleryImages.forEach((img, i) => {
    // Remove existing listeners
    img.removeEventListener("click", img._lightboxHandler);
    
    // Create new handler
    const handler = (e) => {
      e.preventDefault();
      e.stopPropagation();

      // Find this image in the gallery media set if available
      if (window.galleryMediaSet && window.galleryMediaSet.length > 0) {
        const targetIndex = window.galleryMediaSet.findIndex(item => 
          item.type === 'image' && item.element === img
        );
        if (targetIndex !== -1) {
          const caption = window.galleryMediaSet[targetIndex].caption;
          showLightbox(targetIndex, window.galleryMediaSet, caption, 'image');
          return;
        }
      }
      
      // Fallback to original behavior
      showLightbox(i, galleryImages);
    };
    
    // Store handler reference for later removal
    img._lightboxHandler = handler;
    img.addEventListener("click", handler);
  });
  
    // Close button and escape handlers (remove old ones first)
    closeBtn.removeEventListener("click", closeLightbox);
    closeBtn.addEventListener("click", closeLightbox);
    
    lightbox.removeEventListener("click", lightbox._backdropHandler);
    lightbox._backdropHandler = (e) => {
      if (e.target === lightbox) closeLightbox();
    };
    lightbox.addEventListener("click", lightbox._backdropHandler);
    
    // Remove old keydown listener
    if (document._lightboxKeyHandler) {
      document.removeEventListener("keydown", document._lightboxKeyHandler);
    }
    
      // Add new keydown listener
  document._lightboxKeyHandler = (e) => {
    if (lightbox.classList.contains("hidden")) return;
    if (e.key === "Escape") closeLightbox();
    if (e.key === "ArrowRight") showNext(1);
    if (e.key === "ArrowLeft") showNext(-1);
  };
  document.addEventListener("keydown", document._lightboxKeyHandler);
  
  // Navigation button event listeners
  prevBtn.removeEventListener("click", prevBtn._clickHandler);
  prevBtn._clickHandler = (e) => {
    e.stopPropagation();
    showNext(-1);
  };
  prevBtn.addEventListener("click", prevBtn._clickHandler);
  
  nextBtn.removeEventListener("click", nextBtn._clickHandler);
  nextBtn._clickHandler = (e) => {
    e.stopPropagation();
    showNext(1);
  };
  nextBtn.addEventListener("click", nextBtn._clickHandler);
  
  // YouTube link event listener
  lightboxYouTubeLink.removeEventListener("click", lightboxYouTubeLink._clickHandler);
  lightboxYouTubeLink._clickHandler = (e) => {
    pauseVideo(); // Pause the video when opening in YouTube
  };
  lightboxYouTubeLink.addEventListener("click", lightboxYouTubeLink._clickHandler);
    
      // Expose functions globally for Trix images
  window.showLightboxImage = function(imageUrl, index = 0, trixImages = [], caption = '') {
    showLightbox(index, trixImages, caption, 'image');
  };
  
  // Expose function for YouTube videos
  window.showLightboxVideo = function(videoUrl, caption = '') {
    showLightbox(0, [], caption, 'youtube', videoUrl);
  };
    

}
  